<template>
  <div class="atividade-item">
    <router-link
      v-if="props.atividade.id"
      :to="`/home-atividade/${props.atividade.id}`"
      class="atividade-link"
    >
      <button class="atividade-button">
        <div class="atividade-esquerda">
          <div
            class="icon-calendario"
            aria-hidden="true"
          ></div>
          <div class="atividade-info">
            <span class="atividade-nome">{{ props.atividade.nome }}</span>
            <span class="atividade-desc">{{ props.atividade.subtipo }}</span>
            <span class="atividade-desc">
              {{ capitalize(props.atividade.modalidadeExecucao) }}
            </span>
          </div>
        </div>
        <img
          src="@/assets/icons/arrow.svg"
          alt=""
          class="atividade-seta"
        />
      </button>
    </router-link>

    <button
      v-else
      class="atividade-button atividade-button--fallback"
    >
      {{ truncar(props.atividade.nome, 20) }}
      <img
        src="@/assets/icons/right-arrow.png"
        width="15"
        height="15"
        alt=""
      />
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  atividade: {
    type: Object,
    required: true,
  },
});

function capitalize(str = "") {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function truncar(texto = "", limite = 20) {
  if (!texto) return "";
  return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
}
</script>

<style scoped>
.atividade-item {
  width: 90%;
}

.atividade-link {
  width: 100%;
  text-decoration: none;
}

.atividade-button {
  width: 100%;
  padding: 0.5rem;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-radius 0.2s ease;
}

.atividade-button:hover {
  background: #f3f3f3;
  border-radius: 0.4rem;
}

.atividade-button--fallback {
  border: 1.5px solid #000;
  background-color: #fff;
  height: 2.8rem;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0 1rem;
}

.atividade-esquerda {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
}

.icon-calendario {
  padding: 1rem;
  border-radius: 6px;
  border: 6px solid #e2d9fc;
  background: url("@/assets/icons/calendario.png") center / cover no-repeat
    #e2d9fc;
  flex-shrink: 0;
}

.atividade-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;
  min-width: 0;
  text-align: left;
}

.atividade-nome {
  font-size: 0.8rem;
  font-weight: 600;
  color: #111;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.atividade-desc {
  font-size: 0.8rem;
  color: #666;
  line-height: 1.2;
  margin: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.atividade-seta {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
</style>
